/**
 * Tintable motorcycle pictogram used by park-and-ride amenity chips.
 */

import React from "react";

interface MotorcycleIconProps {

    /** Stroke color applied to the pictogram. */
    "color": string;

    /** Optional CSS class for sizing. Defaults to a compact amenity-chip size. */
    "className"?: string;
}

/**
 * Renders a stroke-based motorcycle pictogram tinted via {@link MotorcycleIconProps.color}.
 *
 * @param props Icon props.
 * @returns Inline SVG icon.
 */
const MotorcycleIcon: React.FC<MotorcycleIconProps> = ( {
    color,
    className = "h-3 w-3",
} ) => {
    return (
        <svg
            aria-hidden={true}
            className={className}
            fill="none"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle
                cx="5"
                cy="17"
                r="3"
            />
            <circle
                cx="19"
                cy="17"
                r="3"
            />
            <path d="M12 17h3l2-5h-5l-1 3H8" />
            <path d="M9 9h4l1 3" />
        </svg>
    );
};

export default MotorcycleIcon;
